import request from "@/utils/axios";

//  获取登录信息
export function QUERY(data) {
    return request({
        url: '/api/users/query',
        method: 'get',
        data
    })
}
//  获取头像集合
export function HEADIMGS(data) {
    return request({
        url: '/api/users/headImgs',
        method: 'get',
        data
    })
}
//  更改姓名和密码等信息
export function INFO(data) {
    return request({
        url: '/api/users/info',
        method: 'put',
        data
    })
}
//  退出登录
export function EXIT(data) {
    return request({
        url: '/api/users/exit',
        method: 'get',
        data
    })
}
//  更改头像
export function HEADIMG(data) {
    return request({
        url: '/api/users/headImg',
        method: 'put',
        data
    })
}

//修改密码
export function CHANGEPASSWORD(data) {
    return request({
        url: '/api/users/changePassword',
        method: 'put',
        data
    })
}


//  个人中心-展示购买记录
export function RECORDS(data) {
    return request({
        url: '/api/orderpay/records',
        method: 'post',
        data
    })
}
//  个人中心-逻辑删除购买记录
export function DEL(data) {
    return request({
        url: '/api/orderpay/del',
        method: 'PUT',
        data
    })
}
//  个人中心-逻辑删除购买记录
export function PERMITS(data) {
    if (data) {
        return request({
            url: '/api/setmeal/permits?currentPage=' + data.currentPage + '&size=' + data.size,
            method: 'GET',
            data
        })
    } else {
        return request({
            url: '/api/setmeal/permits',
            method: 'GET',
            data
        })
    }

}
//  获取品牌下拉列表信息
export function brandAll(data) {
    return request({
        url: '/api/industrybrand/brandAll',
        method: 'post',
        data
    })
}
//  获取行业下拉列表信息
export function industryAll(data) {
    return request({
        url: '/api/industrybrand/industryAll',
        method: 'get',
        data
    })
}
//  个人中心-套餐权限设置/新增修改
export function ADDPERMITS(data) {
    return request({
        url: '/api/setmeal/addPermits',
        method: 'post',
        data
    })
}

//  个人中心-套餐修改時間
export function UPDATESTR(data) {
    return request({
        url: '/api/setmeal/updateStr',
        method: 'get',
        data
    })
}

// /api/industrybrand/checkBrandAtPermit
export function CHECKBRANDATPERMIT(data) {
    return request({
        url: '/api/industrybrand/checkBrandAtPermit',
        method: 'post',
        data
    })
}


export function CHECKBRANDS(data) {
    return request({
        url: '/api/setmeal/permits/check',
        method: 'post',
        data
    })
}

//  删除账号
export function DELETEACCOUNT(data) {
    return request({
        url: '/api/users/deleteAccount',
        method: 'post',
        data
    })
}

//  查询聊天套餐剩余次数
export function QUERYBAIDUBCE(data) {
    return request({
        url: '/api/common/baidubce/package',
        method: 'get',
        data
    })
}


//  随机获取三条问题
export function GETTHREEQUESTION(data) {
    return request({
        url: '/api/common/baidubce/random',
        method: 'get',
        data
    })
}


//  点赞点踩
export function LIKEORDISLIKE(data) {
    return request({
        url: '/api/common/baidubce/like',
        method: 'post',
        data
    })
}







